import { Controller } from '@hotwired/stimulus'

const OBSERVED_CLASS = 'life_events__card-reveal-observed'
const ROOT_MARGIN = '100% 0px'

// A timeline can hold hundreds of cards, each wanting its own scroll-driven entry
// animation (motion.css). Letting every one of them carry animation-timeline at once
// keeps them all live on the compositor regardless of distance from the viewport,
// which is expensive enough on a long timeline to freeze the page. An
// IntersectionObserver with a generous margin instead attaches the animation only to
// cards near the viewport, and drops it again once they're well past — so the count
// of live animations stays small no matter how long the timeline grows, without
// guessing at any card's size the way content-visibility would have needed to.
export default class extends Controller {
  static targets = ['card']

  connect () {
    if (!window.IntersectionObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle(OBSERVED_CLASS, entry.isIntersecting))
    }, { rootMargin: ROOT_MARGIN })

    this.cardTargets.forEach((card) => this.observer.observe(card))
  }

  disconnect () {
    this.observer?.disconnect()
  }
}
